if (window.innerWidth > 740) {
    gsap.timeline({
        scrollTrigger: {
            pin: true,
            trigger: '.sidebar-menu .inner',
            start: 'top 25%',
            end: () =>
                `$+=${
                    document.querySelector('.faqs').offsetHeight -
                    window.innerHeight -
                    document.querySelector('sticky-header').offsetHeight
                }`,
            pinSpacing: false,
            invalidateOnRefresh: true,
            scrub: true,
        },
    });
}
